import React from "react";
import { useTranslation } from "react-i18next";

// Material-UI Core Components
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

// Material-UI Icons
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";


function FormHeadingIDAndOwner(props) {
  const { t } = useTranslation();

  const { record } = props;

  const id = record.id;
  const owner = record.owner_user_fullname;

  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", marginLeft: "10px" }}>
      <Tooltip title={t("common.id")}>
        <div style={{ display: "flex", alignItems: "center", marginRight: 16 }}>
          <FingerprintIcon style={{ marginRight: 8 }} />
          <Typography align="left" variant="subtitle2">
            {id}
          </Typography>
        </div>
      </Tooltip>
      <Tooltip title={t("common.owner")}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <AccountCircleIcon style={{ marginRight: 8 }} />
          <Typography align="left" variant="subtitle2">
            {owner}
          </Typography>
        </div>
      </Tooltip>
    </div>
  );
}

export default FormHeadingIDAndOwner;
